import { useEffect } from "react";

function BuyWithPrime({ sku }) {
  useEffect(() => {
    if(typeof window !== 'undefined') {
      const js = window.document.createElement('script');
      js.src = "https://code.buywithprime.amazon.com/bwp.v1.js";
      js.type = "text/javascript";
      js.async = true;
      js.fetchPriority = "high";
      js.id = 'bwpScript';
      document.head.appendChild(js);
    }

    return () => {
      const t = document.getElementById('bwpFrame');
      t && t.parentNode.removeChild(t);
      const s = document.getElementById('bwpScript');
      s && s.parentNode.removeChild(s);
    }
  }, [])

  return (
    <div data-prime-widget-sku={sku} className="buy-with-prime-container relative m-auto w-full flex flex-col">
      <div
        className="order-2"
        id="amzn-buy-now"
        data-site-id="gwfxnozf54"
        data-widget-id="w-XRZsc7Ov0c7a7UehqIg5N0"
        data-sku={sku}
      />
      <div className="or-separator order-1">OR BUY ONE TIME WITH</div>
    </div>
  );
}

export default BuyWithPrime;
